import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

export default class LabelBar extends PureComponent {
  render() {
    const {className, text, clickable, onClick} = this.props;

    return (
      <div className={className} style={{cursor: clickable ? 'pointer' : 'unset'}} onClick={onClick}>
        <span>{text}</span>
      </div>
    );
  }
}

LabelBar.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  clickable: PropTypes.bool,
  onClick: PropTypes.func,
};

LabelBar.defaultProps = {
  className: 'title',
  text: '',
  clickable: false,
  onClick: null,
};
